module.exports = __webpack_public_path__ + "img/Comic08-3.e1c9ab68.png";